import { Component, HostBinding, OnInit } from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { DurationUnits } from 'luxon';
import { RenderSlugService } from 'render/services/render-slug.service';
import { RenderStateService } from 'render/services/render-state/render-state.service';
import { Observable, combineLatest, first, interval, switchMap } from 'rxjs';

import { PieceFinalCountdownSettings } from 'extensions/core/piece-final-countdown/front/models/piece-final-countdown.models';
import { DurationWithPercent, FinalCountDownService } from 'extensions/core/piece-final-countdown/front/services/final-countdown.service';


@Component({
  selector: 'piece-final-countdown-render',
  templateUrl: './piece-final-countdown-render.component.html',
  styleUrls: ['./piece-final-countdown-render.component.scss']
})
export class PieceFinalCountdownRenderComponent
  extends BaseRenderComponent<PieceFinalCountdownSettings>
  implements OnInit {

  public timeToCountdown$!: Observable<DurationWithPercent | undefined>;

  constructor(
    private readonly finalCountdownService: FinalCountDownService,
    private readonly renderSlugService: RenderSlugService,
    private readonly renderStateService: RenderStateService
  ) {
    super();
  }

  @HostBinding('class')
  public get classes(): string {
    return this.settings.styles.customClassesList ?? '';
  }

  @HostBinding('class.theme-box')
  public get themeBox(): boolean {
    return this.settings.styles.theme === 'box';
  }

  public get dateStyle(): PieceFinalCountdownSettings['general']['dateStyle'] | undefined {
    return this.settings.general.dateStyle;
  }

  public get labelStyle(): PieceFinalCountdownSettings['general']['labelStyle'] | undefined {
    return this.settings.general.labelStyle;
  }

  public ngOnInit(): void {
    const generalSettings = this.settings.general;
    const units = this.getUnits(generalSettings.dateStyle);

    const currentDate$ = this.renderStateService.getTimeTravelTo$(this.renderSlugService.getSlug()).pipe(
      switchMap((timeTravelTo) => this.finalCountdownService.getCurrentDate$(timeTravelTo ?? undefined).pipe()),
      first()
    );

    this.timeToCountdown$ = combineLatest([
      currentDate$,
      interval(1000)
    ]).pipe(
      switchMap(([currentDate, additionalSeconds]) => this.finalCountdownService.getTimeToCountdown$(
        currentDate.plus({ seconds: additionalSeconds }),
        generalSettings.typeOfDate === 'local',
        generalSettings.startDate,
        generalSettings.endDate,
        units
      ))
    );
  }

  private getUnits(labelStyle: PieceFinalCountdownSettings['general']['dateStyle']): DurationUnits {
    const units: DurationUnits = [];
    if (labelStyle.showDaysToggle) {
      units.push('days');
    }
    if (labelStyle.showHoursToggle) {
      units.push('hours');
    }
    if (labelStyle.showMinutesToggle) {
      units.push('minutes');
    }
    if (labelStyle.showSecondsToggle) {
      units.push('seconds');
    }
    return units.concat(['milliseconds']);
  }

}
